import React from 'react';
import Icon from '../../../icon';
import useLanguage from '../../../../hooks/useLanguage';
import {formatDateRange} from '../../../../utils';
import {MediaList} from './MediaList';
import {SkillPills} from './SkillPills';

interface ExperienceItemProps {
  role?: string;
  company?: string;
  startDate?: string;
  endDate?: string;
  description?: string | string[];
  summary?: string[] | null;
  media?: string[];
  skills?: Array<{
    name: string;
    rating?: number | null;
    count?: number | null;
  }>;
  className?: string;
  onImageLoad?: (src: string) => void;
}

export function ExperienceItem({
  role,
  company,
  startDate,
  endDate,
  description,
  summary,
  media,
  className = '',
  skills,
  onImageLoad,
}: ExperienceItemProps) {
  const [lang] = useLanguage();
  const dateRangeLabel = formatDateRange(startDate, endDate, lang);
  return (
    <section className="pt-6 break-inside-avoid">
      <div
        className={`bg-gray-100 rounded-lg p-4 flex flex-col gap-3 relative ${className}`}>
        <div className="flex justify-between items-start">
          <div className="flex flex-col gap-1">
            <div className="flex flex-col">
              <h3 className="text-md font-bold leading-tight text-gray-800">
                {role}
              </h3>
              <p className="text-sm font-semibold leading-tight text-primary">
                {company}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="calendar-outline" className="w-4 h-4 text-gray-500" />
            <span className="text-sm font-normal leading-tight text-gray-500">
              {dateRangeLabel}
            </span>
          </div>
        </div>
        {description && description.length > 0 && (
          <div className="text-md font-normal leading-tight text-gray-800 space-y-1">
            {Array.isArray(description) ? (
              description.map((desc, index) => <div key={index}>{desc}</div>)
            ) : (
              <div>{description}</div>
            )}
          </div>
        )}

        {/* Summary Section */}
        {summary && summary.length > 0 && (
          <div className="text-md font-normal leading-tight text-gray-800">
            <ul className="list-disc list-inside ml-2">
              {summary.map((item, index) => (
                <li key={index} className="text-sm">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Media List */}
        <MediaList media={media} onImageLoad={onImageLoad} />
        <SkillPills skills={skills} />

        <div className="flex justify-end">
          <div className="flex items-center gap-1">
            <Icon name="qr-code-outline" className="w-4 h-4 text-primary" />
            <span className="text-sm font-bold text-primary leading-tight">
              Bekijk mijn profiel op Slip
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
